module.exports = __webpack_public_path__ + "img/UCL360_banner3_m.a8c115ed.png";